import React, { useState, useEffect } from "react";
import { Container, Navbar, Nav, NavDropdown, Row, Col } from "react-bootstrap";
import "./Navbar.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../_actions";
import Images from "../images/index";
import axios from "axios";
import { LinkContainer } from "react-router-bootstrap";
import SRCLogo from "../images/JSGIFSRCLogo 1.jpg";

function JsgNavbar() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authentication.user);

  const [regions, setRegions] = useState([]);
  const fetchRegions = async () => {
    const response = await axios.get("/user/region");

    setRegions(response.data.sort((a, b) => a.region.localeCompare(b.region)));
  };

  useEffect(() => {
    fetchRegions();
  }, []);

  const [groups, setGroups] = useState([]);
  const fetchGroups = async () => {
    const response = await axios.get("/user/group");

    setGroups(response.data);
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  const signoutSession = () => {
    sessionStorage.removeItem("user");
    localStorage.removeItem("user");
    dispatch(userActions.login({}));
  };

  const navigate = useNavigate();

  return (
    <div>
      <Navbar
        fixed="top"
        collapseOnSelect
        className="navbarBg"
        expand="lg"
        bg="dark"
        variant="dark"
      >
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand>
              <img
                alt=""
                src={Images.Logo}
                width="75"
                height="75"
                className="d-inline-block align-top brandImage"
              />{" "}
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav navbarScroll className="ms-auto">
              <LinkContainer to="/">
                <Nav.Link>Home</Nav.Link>
              </LinkContainer>

              <NavDropdown title="About Us" id="collasible-nav-dropdown">
                <LinkContainer to="/aboutus">
                  <NavDropdown.Item>About JSGIF</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/testimonials">
                  <NavDropdown.Item>Testimonials</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/media-coverages">
                  <NavDropdown.Item>Media Coverages</NavDropdown.Item>
                </LinkContainer>
              </NavDropdown>

              <NavDropdown title="Federation" id="collasible-nav-dropdown">
                <NavDropdown.Header>JSGIF</NavDropdown.Header>

                <LinkContainer to="/founders">
                  <NavDropdown.Item>JSGIF Founders</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/former-presidents">
                  <NavDropdown.Item>JSGIF Former Presidents</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/fed/ob/2025-27">
                  <NavDropdown.Item>JSGIF Office Bearers</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/fed/id/2025-27">
                  <NavDropdown.Item>
                    JSGIF International Directors
                  </NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/constitution-index">
                  <NavDropdown.Item>JSGIF Constitution</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/oath-of-office">
                  <NavDropdown.Item>Oath of Office</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/kartavya">
                  <NavDropdown.Item>Kartavya</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/samvid">
                  <NavDropdown.Item>Samvid</NavDropdown.Item>
                </LinkContainer>

                <NavDropdown.Header>Downloads</NavDropdown.Header>

                <LinkContainer to="/logo-downloads">
                  <NavDropdown.Item>Download Logos</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/theme-song">
                  <NavDropdown.Item>JSGIF Theme Song</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/navkar-mahamantra">
                  <NavDropdown.Item>Navakar Mahamantra</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/reg/zoom-background">
                  <NavDropdown.Item>Zoom Background</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/banner-download/group">
                  <NavDropdown.Item>Group Banner</NavDropdown.Item>
                </LinkContainer>

                <LinkContainer to="/banner-download/region">
                  <NavDropdown.Item>Region Banner</NavDropdown.Item>
                </LinkContainer>
              </NavDropdown>

              <NavDropdown title="South Region" id="collasible-nav-dropdown">
                <NavDropdown.Header>South Region</NavDropdown.Header>
                <LinkContainer to="/region/south">
                  <NavDropdown.Item>JSGIF South Region</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/fed/committee/2025-27">
                  <NavDropdown.Item>Venture Committee</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/reg/rnr">
                  <NavDropdown.Item>Rules & Regulations</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/reg/sop">
                  <NavDropdown.Item>SOP</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/reg/sangini-constitution">
                  <NavDropdown.Item>Sangini Constitution</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/reg/secunderabad-constitution">
                  <NavDropdown.Item>
                    CONSTITUTION OF JAIN SOCIAL GROUP SECUNDERABAD
                  </NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/reg/bank-details">
                  <NavDropdown.Item>Bank Details</NavDropdown.Item>
                </LinkContainer>
              </NavDropdown>

              <NavDropdown title="Forms" id="collasible-nav-dropdown">
                <NavDropdown.Header>Group Forms</NavDropdown.Header>
                <LinkContainer to="form/grp-form-a">
                  <NavDropdown.Item>Form A</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="form/grp-form-b">
                  <NavDropdown.Item>Form B</NavDropdown.Item>
                </LinkContainer>

                <NavDropdown.Header>Venture Forms</NavDropdown.Header>
                {(() => {
                  if (
                    typeof user !== "undefined" &&
                    typeof user.username !== "undefined"
                  ) {
                    return (
                      <>
                        <LinkContainer to="/form/aaina">
                          <NavDropdown.Item>SRC Aaina</NavDropdown.Item>
                        </LinkContainer>

                        <LinkContainer to="/form/eminence/4">
                          <NavDropdown.Item>
                            {/* SRC Eminence 3rd Edition */}
                            SRC Eminence 4th Edition
                          </NavDropdown.Item>
                        </LinkContainer>
                      </>
                    );
                  }
                })()}
                <LinkContainer to="/form/pari-application-form">
                  <NavDropdown.Item>SRC Pari</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/form/udaan-group-form">
                  <NavDropdown.Item>SRC Udaan</NavDropdown.Item>
                </LinkContainer>
              </NavDropdown>

              {(() => {
                if (
                  (typeof user !== "undefined" &&
                    typeof user.username !== "undefined" &&
                    user.accessGroup === "admin") ||
                  (typeof user !== "undefined" &&
                    typeof user.username !== "undefined" &&
                    user.accessGroup === "aaina") ||
                  (typeof user !== "undefined" &&
                    typeof user.username !== "undefined" &&
                    user.accessGroup === "eminence") ||
                  (typeof user !== "undefined" &&
                    typeof user.username !== "undefined" &&
                    user.accessGroup === "pari") ||
                  (typeof user !== "undefined" &&
                    typeof user.username !== "undefined" &&
                    user.accessGroup === "udaan")
                ) {
                  return (
                    <NavDropdown title="Admin" id="collasible-nav-dropdown">
                      <NavDropdown.Header>Responses</NavDropdown.Header>
                      {(() => {
                        if (
                          (typeof user !== "undefined" &&
                            typeof user.username !== "undefined" &&
                            user.accessGroup === "admin") ||
                          (typeof user !== "undefined" &&
                            typeof user.username !== "undefined" &&
                            user.accessGroup === "aaina")
                        ) {
                          return (
                            <LinkContainer to="aaina">
                              <NavDropdown.Item>Aaina</NavDropdown.Item>
                            </LinkContainer>
                          );
                        }
                      })()}
                      {(() => {
                        if (
                          (typeof user !== "undefined" &&
                            typeof user.username !== "undefined" &&
                            user.accessGroup === "admin") ||
                          (typeof user !== "undefined" &&
                            typeof user.username !== "undefined" &&
                            user.accessGroup === "eminence")
                        ) {
                          return (
                            <LinkContainer to="list/eminence/4">
                              <NavDropdown.Item>
                                Eminence 4th Edition
                                {/* Eminence 3rd Edition */}
                              </NavDropdown.Item>
                            </LinkContainer>
                          );
                        }
                      })()}
                      {(() => {
                        if (
                          (typeof user !== "undefined" &&
                            typeof user.username !== "undefined" &&
                            user.accessGroup === "admin") ||
                          (typeof user !== "undefined" &&
                            typeof user.username !== "undefined" &&
                            user.accessGroup === "aaina")
                        ) {
                          return (
                            <LinkContainer to="ventures/pari">
                              <NavDropdown.Item>Pari</NavDropdown.Item>
                            </LinkContainer>
                          );
                        }
                      })()}
                      {(() => {
                        if (
                          (typeof user !== "undefined" &&
                            typeof user.username !== "undefined" &&
                            user.accessGroup === "admin") ||
                          (typeof user !== "undefined" &&
                            typeof user.username !== "undefined" &&
                            user.accessGroup === "udaan")
                        ) {
                          return (
                            <LinkContainer to="list/udaan">
                              <NavDropdown.Item>Udaan</NavDropdown.Item>
                            </LinkContainer>
                          );
                        }
                      })()}
                    </NavDropdown>
                  );
                }
              })()}

              {(() => {
                if (
                  typeof user !== "undefined" &&
                  typeof user.username !== "undefined" &&
                  user.accessGroup === "aaina"
                ) {
                  return (
                    <NavDropdown title="Aaina" id="collasible-nav-dropdown">
                      <NavDropdown.Header>Responses</NavDropdown.Header>
                      <LinkContainer to="aaina">
                        <NavDropdown.Item>Aaina</NavDropdown.Item>
                      </LinkContainer>
                    </NavDropdown>
                  );
                }
              })()}

              {/* <NavDropdown title="Ventures" id="collasible-nav-dropdown">
                <LinkContainer to="/ventures/aashray">
                  <NavDropdown.Item>JSGIF Aashray</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/ventures/ask-jsg">
                  <NavDropdown.Item>JSGIF Ask JSG</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/ventures/constitution-&-bylaws">
                  <NavDropdown.Item>
                    JSGIF Constitution & Bylaws
                  </NavDropdown.Item>
                </LinkContainer>
                
                <LinkContainer to="/ventures/runbhoomi">
                  <NavDropdown.Item>JSGIF Runbhoomi</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/ventures/strot">
                  <NavDropdown.Item>JSGIF Strot</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/ventures/udaan">
                  <NavDropdown.Item>JSGIF Udaan</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/ventures/vidya">
                  <NavDropdown.Item>JSGIF Vidya</NavDropdown.Item>
                </LinkContainer>
              </NavDropdown> */}

              {(() => {
                if (
                  typeof user !== "undefined" &&
                  typeof user.username !== "undefined"
                ) {
                  return (
                    <LinkContainer to="/">
                      <Nav.Link onClick={signoutSession}>Sign Out</Nav.Link>
                    </LinkContainer>
                  );
                } else
                  return (
                    <LinkContainer to="/login">
                      <Nav.Link>Sign In</Nav.Link>
                    </LinkContainer>
                  );
              })()}
              <LinkContainer to="/" style={{ padding: "0 10px" }}>
                <Navbar.Brand>
                  <img
                    alt=""
                    src={SRCLogo}
                    width="75"
                    height="75"
                    className="d-inline-block align-top brandImage"
                  />{" "}
                </Navbar.Brand>
              </LinkContainer>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default JsgNavbar;
